<template>
  <div>
    <div class="position-relative">
      <section class="section section-sm bg-custom-bg-color" style="margin-top: 90px">
        <div class="container p-0">


          <div class="bg-white p-3 rounded-3">

            <div class="row m-0 justify-content-between">
              <h2 class="display-3 text-custom-text ">訂單管理</h2>
              <div>
                <base-input placeholder="搜尋訂單關鍵字..." addon-left-icon="text-custom-text fa fa-search"></base-input>
              </div>
            </div>


            <div class="row m-0 justify-content-between">
              <h5 class="text-custom-text ">共 {{ total_order_Count }} 筆</h5>
              <div class="row m-0 align-items-center">
                <base-button outline type="main-color" style="padding: 1px 8px">排序</base-button>
                <p class="m-0 text-custom-text font-weight-500"> 依最後編輯時間 </p>
              </div>
            </div>

            <div class="mt-5"></div>

            <div class="d-grid grid-gap">
              <div v-for="(item, index) in order_list" :key="index" class="grid-item">
                <OrderItem
                    :order_id="item.order_id"
                    :order_type="item.order_type"
                    :title="item.title"
                    :create_time="item.create_time"
                    :update_time="item.update_time"
                    :price_data="item.price_data"
                    :item_list="item.item_list"
                />
              </div>
            </div>

            <div class="mt-5"></div>
            <div>
              <base-pagination :page-count="pageCount" align="center" v-model="page"></base-pagination>
            </div>

            <div class="mt-5"></div>


            <div class="mx-5">
              <p class="text-main-color font-weight-500">注意事項</p>
              <ul>
                <li>訂購商品之出貨，是由國外廠商掌控，無法保證如期、如數出貨。實際交貨之日期、品項、規格及數量，以國外廠商出貨後，本公司之通知為準。</li>
                <li>為確保訂購人履行給付貨款之債務，本公司得就特定商品及訂單金額或數量過高時，向訂購人收取定金。若訂購人未付定金者，本公司得拒絕、取消或變更訂單之全部或一部份。</li>
                <li>訂購人應該「商品訂購買賣契約書」之約定付款。若未依約付款者，本公司將依「商品訂購買賣契約書」及「預睡保證金協議書」之違約罰責及相關約定處理。</li>
                <li>非透過萬榮訂購之商品，如有瑕疪或盒損，不予以處理。</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>

import OrderItem from "@/views/components/elements/OrderItem";

export default {
  name: "OrderView",
  components: {
    OrderItem: OrderItem,
  },
  props: {
    order_list: {
      type: Array,
      default: function() {
        return [
          {
            order_id: "206513344138542",
            order_type: "未結單",
            title: "BANDAI食玩8月新品",
            create_time: "2023/05/20 23:15:12",
            update_time: "2023/05/20 23:15:12",
            price_data: {
              unit: "TWD",
              price: "508996"
            },
            item_list: [
              {
                title: "安妮亞 01",
                note: "",
                amount: 1,
                delivery_time: '2023/7',
                price_data: {
                  unit: "TWD",
                  price: "999"
                },
                img: this.$baseUrl + "img/anya/anya01.png",
                tag_list: [
                  {text: 'banpresto', color: 'blue'},
                  {text: 'PVC', color: 'green'},
                ],
                total_price: 1000,
                price: 500,
                discount: 0.70,
                combine_buy_discount: 0.80,
                combine_buy_amount: 1,
                exchange_rate: 0.22,
                decrease: 5,
                stock: 10,
                actual_stock: 10,
                history_list : [
                  {
                    title: "更新下單數量",
                    create_data: "2023/07/15 20:15:32",
                    before_text: "250 PCS",
                    after_text: "220 PCS",
                  },
                  {
                    title: "更新下單數量",
                    create_data: "2023/07/15 20:15:32",
                    before_text: "250 PCS",
                    after_text: "220 PCS",
                  },
                ]
              }
            ]
          },
          {
            order_id: "99999999",
            order_type: "結單",
            title: "BANDAI食玩10月新品",
            create_time: "2023/05/20 23:15:12",
            update_time: "2023/05/20 23:15:12",
            price_data: {
              unit: "TWD",
              price: "1000"
            },
            item_list: [
              {
                title: "安妮亞 40",
                note: "",
                amount: 1,
                delivery_time: '2023/7',
                price_data: {
                  unit: "TWD",
                  price: "1000"
                },
                img: this.$baseUrl + "img/anya/anya40.png",
                tag_list: [
                  {text: 'banpresto', color: 'blue'},
                  {text: 'PVC', color: 'green'},
                ],
                total_price: 1000,
                price: 1000,
                discount: 1.00,
                combine_buy_discount: 1.00,
                combine_buy_amount: 1,
                exchange_rate: 0.22,
                decrease: 0,
                stock: 1,
                actual_stock: 1,
                history_list : [
                  {
                    title: "更新下單數量",
                    create_data: "2023/07/15 20:15:32",
                    before_text: "0 PCS",
                    after_text: "1 PCS",
                  },
                  {
                    title: "更新下單數量",
                    create_data: "2023/07/15 20:15:32",
                    before_text: "1 PCS",
                    after_text: "12 PCS",
                  },
                ]
              }
            ]
          },
        ];
      }
    },

    page: {
      type: Number,
      default: 1,
    },
    pageCount: {
      type: Number,
      default: 1,
    },
    itemsPerPage: {
      type: Number,
      default: 8,
    },
    total_order_Count:{
      type: Number,
      default: 1,
    }
  },
  data() {
    return {
      // length: 1,
      // page: 1,
      // pageCount: 10,
    };
  },
};
</script>

<style lang="scss" scoped>

.mb-150 {
  margin-bottom: 150px;
}

.grid-gap {
  grid-gap: 30px;
}
</style>
